var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// C:/thinkbit/conference/hosting/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 18